import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';
import CardInnerSkeleton from './CardInnerSkeleton';

const VehicleCardSkeleton = ({ isGridLayout, isTabbedLayout }) => {
	return (
		<li
			className={setClassNames([
				'vehicle-card',
				'vehicle-card-detailed',
				isGridLayout ? null : 'vehicle-card-horizontal horizontal'
			])}
		>
			<CardInnerSkeleton
				{...{isGridLayout, isTabbedLayout}}
			/>
		</li>
	);
};

VehicleCardSkeleton.propTypes = {
	isGridLayout: PropTypes.bool.isRequired,
	isTabbedLayout: PropTypes.bool.isRequired
};

export default VehicleCardSkeleton;
